// src/hooks/useViewportOffset.js
import { useEffect } from "react";

/**
 * Tracks the gap between the layout viewport (window.innerHeight) and the
 * visual viewport (what's actually visible on screen). On mobile that gap
 * is the height of whatever browser chrome (URL bar / bottom nav) is
 * currently covering the page. Exposes it as --browser-toolbar-offset so
 * any fixed-bottom element can pad/shift itself clear of it, instead of
 * hardcoding a guessed pixel value.
 *
 * Call this once near the root of the app (e.g. App.jsx).
 */
export function useViewportOffset() {
  useEffect(() => {
    const root = document.documentElement;

    const update = () => {
      const vv = window.visualViewport;
      const offset = vv
        ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop)
        : 0;
      root.style.setProperty("--browser-toolbar-offset", `${offset}px`);
    };

    update();

    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);

    return () => {
      window.visualViewport?.removeEventListener("resize", update);
      window.visualViewport?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);
}
